module.exports = __webpack_public_path__ + "media/images/email/ic_selected-3b0c92a22447d52d0d04bda8ab1d315d.svg";